export default {"src":"/_next/static/media/map-mobile.2bef6b99.svg","height":432,"width":375,"blurWidth":0,"blurHeight":0};